import {useApi} from 'quickstart/hooks/useApi'
import {type Falsy, logger} from 'tizra'

const log = logger('blocks/admin/hooks/usePropValues')

const EMPTY = [] as string[]

/**
 * A property's values, or nothing when asked for nothing.
 *
 * `prop` accepts a falsy value so a caller that doesn't want the values this
 * render can decline the fetch without skipping the hook call itself — hooks
 * are called unconditionally, so the saving has to come from the query being
 * disabled rather than from the call being conditional. This is the same
 * idiom `useApi.canAccess(tizraId && !metaObj?.isFree && {tizraId})` uses:
 * `makeQueryParams` reads a falsy first argument as disabled, so passing the
 * falsy `prop` straight through is enough (design.md — Decision 1a).
 *
 * Under the reskin, the four value-backed typeahead fields pass `undefined`
 * here and bind their control to the property instead, so the values load
 * only when the control is used. Classic, which has no such control, always
 * passes a real property name and keeps loading with the form.
 */
export const usePropValues = (
  prop: string | Falsy,
  metaType = 'AdminTagged',
) => {
  const {data} = useApi.propValues(
    prop && {
      metaType,
      propNames: [prop],
    },
  )
  let values = prop ? data?.[prop] : undefined
  if (values && prop === 'AdminTags') {
    values = values.filter(t => !t.includes(';')) // ;agilepdf_crawlers;
  }
  return values || EMPTY
}
